import { useLocalization } from '../useLocalization';
import { PRICE_DISCLAIMER_COUNTRIES } from '~~/constants/priceDisclaimerCountries';

export default function () {

  const { countryCode } = useLocalization();
  const isPriceDisclaimerEnabled = computed(() => PRICE_DISCLAIMER_COUNTRIES.includes(countryCode.value));

  return { isPriceDisclaimerEnabled };

}
